import { Translation } from 'cng-common/features/translations'

import { STRATEGIC_INITIATIVES_TRANSLATION_KEYS } from '../../../configs/translations'
import {
  useStrategicInitiativesFiscalYear,
  useStrategicInitiativesOffering,
  useStrategicInitiativesRtm,
} from '../../../model'
import { StrategicInitiativesFiscalYear } from '../../strategicInitiativesFiscalYear'
import { StrategicInitiativesOffering } from '../../strategicInitiativesOffering'
import { StrategicInitiativesRtm } from '../../strategicInitiativesRtm'
import { StrategicInitiativesTable } from '../../strategicInitiativesTable'

import styles from './StrategicInitiatives.module.scss'

export const StrategicInitiatives = () => {
  const { fYear, setFYear } = useStrategicInitiativesFiscalYear()
  const { rtm, setRtm } = useStrategicInitiativesRtm()
  const { offering, setOffering, offerings } = useStrategicInitiativesOffering()

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Translation text={STRATEGIC_INITIATIVES_TRANSLATION_KEYS.title} />
      </div>

      <div className={styles.controlsTile}>
        {fYear !== null && <StrategicInitiativesFiscalYear fYear={fYear} onChange={setFYear} />}
        <StrategicInitiativesRtm rtm={rtm} onChange={setRtm} />
        {offering !== null && (
          <StrategicInitiativesOffering
            offerings={offerings}
            offering={offering}
            onChange={setOffering}
          />
        )}
      </div>

      <div className={styles.tableTile}>
        <StrategicInitiativesTable />
      </div>
    </div>
  )
}

StrategicInitiatives.displayName = 'StrategicInitiatives'
